import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DropdownMenu } from '@3plearning/react-components';
import { ALL_TEACHERS, TEACHER_LIST } from '../filter-constants';
import { dropdownItemPropType } from '../filter-prop-types';
import dropdownDataSelectors from '../redux/dropdown-data/dropdown-data-selectors';
import dropdownDataActions from '../redux/dropdown-data/dropdown-data-actions';
import {
    getTranslatedOptions,
    getTranslateSelectedOption
} from './dropdown-helpers';

export class TeacherDropdown extends PureComponent {
    static propTypes = {
        teacherDropdownData: PropTypes.shape({
            data: PropTypes.arrayOf(dropdownItemPropType),
            selectedOption: dropdownItemPropType,
            disabled: PropTypes.bool
        }),
        className: PropTypes.string,
        setSelectedTeacher: PropTypes.func,
        applyFilters: PropTypes.func.isRequired
    };

    render() {
        const {
            teacherDropdownData,
            className,
            setSelectedTeacher,
            applyFilters
        } = this.props;
        const { data, selectedOption, disabled } = teacherDropdownData;
        const i18n = window.i18n;
        return (
            <DropdownMenu
                className={className}
                options={getTranslatedOptions(data, ALL_TEACHERS, i18n)}
                selectedOption={getTranslateSelectedOption(
                    selectedOption,
                    ALL_TEACHERS,
                    i18n
                )}
                onSelectOption={(e) => {
                    setSelectedTeacher(e);
                    applyFilters();
                }}
                disabled={disabled}
            />
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        teacherDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            TEACHER_LIST
        )(state)
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        { setSelectedTeacher: dropdownDataActions.setSelectedTeacher },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(TeacherDropdown);



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/teacher-dropdown.js